import React, { useState, useEffect } from "react";
import { LinearProgress, Box, Typography } from "@mui/material";
import { useInView } from "react-intersection-observer";

const skills = [
  { name: "Interior Design", value: 95 },
  { name: "Industrial Design", value: 95 },
];

function SkillsOther() {
  return (
    <section className="skills section-padding pt-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="skil-progs md-mb80">
              <Typography variant="text" className="main-color">
                Other
              </Typography>
              <Typography variant="h3">
                Design <span className="fw-300">Skills</span>
              </Typography>
              <Typography variant="body2" className="fz-13 mt-15">
                Knowledge from cross-industry experience provides a better understanding of diverse perspectives, innovative solutions, and the ability to adapt and apply best practices across various fields.
              </Typography>

              {skills.map((skill, index) => (
                <SkillItem key={index} skill={skill} />
              ))}
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div className="resume-exp">
              <div className="box-items row mt-100">
                <div className="col-md-12 item">
                  <Typography variant="h6" className="text-center">
                    <span className="num">
                      1 <small>st</small>
                    </span>
                    <br />
                    Interior Designer
                    <br />
                    <span className="opacity-8">2018 - 2019</span>
                    <br />
                    <span className="opacity-3 fz-12">SCA Designs (Ong & Ong Group)</span>
                  </Typography>
                </div>
                <div className="col-md-12 item">
                  <Typography variant="h6" className="text-center">
                    <span className="num">
                      2 <small>nd</small>
                    </span>
                    <br />
                    Industrial Designer - Design Manager
                    <br />
                    <span className="opacity-8">2010 - 2015</span>
                    <br />
                    <span className="opacity-3 fz-12">Sterling Products</span>
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function SkillItem({ skill }) {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (inView) {
      setProgress(0);
      const increment = skill.value / 100;
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev < skill.value) {
            return prev + increment;
          } else {
            clearInterval(interval);
            return skill.value;
          }
        });
      }, 10);
      return () => clearInterval(interval);
    }
  }, [inView, skill.value]);

  return (
    <div className="skill-item mt-30" ref={ref}>
      <Typography variant="h6" className="fz-16 mb-10">
        {skill.name}
      </Typography>
      <Box className="skill-progress" display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: "10px",
              backgroundColor: "#00000021",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "yellowgreen",
              },
            }}
          />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="white">{`${Math.round(
            progress
          )}%`}</Typography>
        </Box>
      </Box>
    </div>
  );
}

export default SkillsOther;

